<!--
 * @Desc: 菜单
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-06 09:43:24
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <section class="recommend-hold">
        <div class="title">最新动态</div>
        <div class="divider"></div>
        <div class="recommend-list">
            <div class="recommend-item" @click="toDetail(item)" v-for="(item,idx) in recommendList" :key="idx">
                <div class="recommend-item-time">{{ timestampToTime(item.updated_at,4) }}</div>
                <div class="recommend-item-title ellipsis1">
                    {{ item.title }}
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Utils from "@/api/Utils";
export default {
    data() {
        return {
            recommendList:''
        };
    },
    props: {
        // 数据
        recommendData: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {
        let that = this;
        that.newArticle()
    },
    methods: {
        // 跳转详情
        toDetail(item){
            this.$toPath('/NewsDetail?active='+item.cate_id+'&id=' +item.id,{})
        },
        // 格式化时间
        timestampToTime(timestamp, type){
            return Utils.timestampToTime(timestamp, type)
        },
        // 获取最新动态列表
        newArticle(){
            let that = this
            this.$api.index.newArticle({}).then((res)=>{
                if(res.code == 200) {
                    // console.log(res.result)
                    that.recommendList = res.result
                }
            })
        },
        /**
         * @name: 点击事件
         * @return {*}
         * @desc: 点击事件
         */
        navClick(event) {
            let url = event.target.getAttribute("data-src");
            if (!url) return;
            this.$toPath(url, {});
        },
    },
};
</script>

<style scoped>
.recommend-hold {
}
.recommend-hold .title {
    padding-left: 42px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 32px;
    color: rgba(226, 47, 36, 1);
    background: url(../../../public/statics/images/SchoolNews/icon_time.png)
        no-repeat left center;
}
.recommend-hold .divider {
    width: 344px;
    height: 2px;
    background: #e22f24;
    margin: 15px 0;
}
.recommend-hold .recommend-list {
    position: relative;
}
.recommend-hold .recommend-list::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 100%;
    background: #e6e6e6;
}
.recommend-hold .recommend-list .recommend-item {
    padding-left: 32px;
    margin-top: 15px;
    position: relative;
    z-index: 2;
    cursor: pointer;
}
.recommend-hold .recommend-list .recommend-item::after {
    content: "";
    position: absolute;
    top: 11px;
    left: -3px;
    width: 6px;
    height: 6px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(230, 230, 230, 1);
}
.recommend-hold .recommend-list .recommend-item .recommend-item-time {
    width: 58px;
    height: 25px;
    background: url(../../../public/statics/images/SchoolNews/icon-title-bg.png)
        no-repeat left center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-family: AppleSystemUIFont;
    color: #e22f24;
}
.recommend-hold .recommend-list .recommend-item .recommend-item-title {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    margin-top: 10px;
    padding-right: 50px;
}
/* 滑入效果 */
.recommend-hold .recommend-list .recommend-item:hover .recommend-item-title{
    color: #e22f24;
}
</style>
